import { tuneInEventValidators } from '@tunein/web-schema-validator';
import { fetchWithRetry, isServer, mapKeys, mapValues, } from '@tunein/web-utils';
import deepmerge from 'deepmerge';
import { v4 as uuidv4 } from 'uuid';
import { BATCH_REPORTS_INTERVAL_SECS, MAX_BATCH } from '../constants/reporting';
import tuneInEventFieldsByType from '../constants/tuneInEventFieldsByType';
import { QueueBatchProcessor } from '../coordinators/QueueBatchProcessor';
export default function reportingService(config, apiContext, applyReauth, services) {
    const eventsApi = `${config.domains.event}/events/client-reports`;
    const queueBatchProcessor = new QueueBatchProcessor({
        callback: sendBatch,
        intervalDelaySecs: config.reportingIntervalDelaySecs || BATCH_REPORTS_INTERVAL_SECS,
        maxBatch: config.reportingMaxBatch || MAX_BATCH,
    });
    if (!isServer()) {
        queueBatchProcessor.init();
    }
    function sendBatch(batch) {
        return fetchWithRetry(eventsApi, {
            post: {
                device_id: config.serial,
                sent_at: new Date().toJSON(),
                data: batch,
            },
            parseAs: 'text',
        });
    }
    function transformReportingData(dataToTransform) {
        if (isServer()) {
            return data;
        }
        const { event, context } = dataToTransform;
        return {
            ...event,
            context: {
                ...(event?.context ? deepmerge(context, event.context) : context),
                partnerId: config.partnerId,
                deviceId: config.serial,
                locale: window.navigator?.language || '',
                userAgent: window.navigator?.userAgent || '',
                timezone: new Intl.DateTimeFormat()?.resolvedOptions()?.timeZone || '',
                app: {
                    version: config.version?.toString() || '',
                },
                page: {
                    path: window.location?.pathname || '',
                },
                screen: {
                    height: window.screen?.height || 0,
                    width: window.screen?.width || 0,
                },
            },
        };
    }
    function mapKeysToReport(v, k) {
        return k.replace('validate', 'report');
    }
    function mapValuesToReporter(validator, validatorName) {
        return function validateAndAddToQueue(data) {
            const baseFields = tuneInEventFieldsByType[validatorName] ||
                tuneInEventFieldsByType.unspecified;
            const eventData = {
                messageId: uuidv4(),
                eventTs: new Date().toJSON(),
                ...baseFields,
                ...transformReportingData(data),
            };
            const errors = validator(eventData);
            if (errors) {
                if (config.debug) {
                    console.error(`Error in web-api-client schema validator ${validatorName}`, errors);
                }
                services.logging.errorLog({
                    message: `Schema Validation Error: ${validatorName}`,
                    context: errors,
                });
                return null;
            }
            queueBatchProcessor.addToQueue(eventData);
        };
    }
    return mapValues(mapKeys(tuneInEventValidators, mapKeysToReport), mapValuesToReporter);
}
